import React from 'react'
import WizardInput from '../../../../../../components/WizardModal/WizardInput'
import WizardTextarea from '../../../../../../components/WizardModal/WizardTextarea'
import WizardFileUpload from '../../../../../../components/WizardModal/WizardFileUpload'
import WizardCheckbox from '../../../../../../components/WizardModal/WizardCheckbox'

export interface GeneralInquiryData {
  subject: string
  description: string
  attachments: File[]
  isUrgent: boolean
}

interface GeneralInquiryStepProps {
  value: GeneralInquiryData
  onChange: (value: GeneralInquiryData) => void
}

const GeneralInquiryStep = ({ value, onChange }: GeneralInquiryStepProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
    <div>
      <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>General Inquiry</h3>
      <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: 0 }}>Describe your request and attach any relevant files.</p>
    </div>

    <WizardInput
      label="Subject"
      required
      placeholder="Brief summary of your request..."
      value={value.subject}
      onChange={(subject) => onChange({ ...value, subject })}
    />

    <WizardTextarea
      label="Description"
      required
      placeholder="Describe your question or request in detail..."
      value={value.description}
      onChange={(description) => onChange({ ...value, description })}
      maxLength={1000}
    />

    <WizardFileUpload
      files={value.attachments}
      onChange={(attachments) => onChange({ ...value, attachments })}
    />

    <WizardCheckbox
      label="Mark as urgent"
      description="Check this if your request requires immediate attention from our team."
      checked={value.isUrgent}
      onChange={(isUrgent) => onChange({ ...value, isUrgent })}
      showInfoIcon
    />
  </div>
)

export default GeneralInquiryStep
